import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CornerRadiusModel } from '../../../models/corner-radius.model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'agpr-corner-radius',
    templateUrl: './corner-radius.component.html',
    styleUrls: ['./corner-radius.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: CornerRadiusComponent
        }
    ],
    standalone: false
})
export class CornerRadiusComponent implements ControlValueAccessor {

    @Input() id: string;
    @Input() cornerRadius: CornerRadiusModel = new CornerRadiusModel();
    @Input() showInfoTooltip = false;
    @Input() verticalOnly = false;
    @Output() cornerRadiusChanged = new EventEmitter<CornerRadiusModel>();

    constructor() {}

    writeValue(value: any): void {
        this.cornerRadius = value;
    }

    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    registerOnChange(fn): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }

    optionChange(event: boolean) {
        if (event) {
            if (this.verticalOnly){
                this.cornerRadius.bottomLeftCornerRadius = this.cornerRadius.topLeftCornerRadius = this.cornerRadius.cornerRadiusAll;
                this.cornerRadius.topRightCornerRadius =  this.cornerRadius.bottomRightCornerRadius = 0;
            } else {
                this.cornerRadius.bottomLeftCornerRadius = this.cornerRadius.topRightCornerRadius = this.cornerRadius.topLeftCornerRadius =
                this.cornerRadius.bottomRightCornerRadius = this.cornerRadius.cornerRadiusAll;
            }
        } else {
            this.cornerRadius.cornerRadiusAll = this.cornerRadius.topLeftCornerRadius;
        }
        this.cornerRadius.cornerRadiusOption = event;
        this.onValueChange();
    }

    onValueChange() {
        this.onModelChange(this.cornerRadius);
        this.cornerRadiusChanged.emit(this.cornerRadius);
    }
}
